import { APISettings } from '../config.js';
import loginMethods from '../resources/loginMethods.js'

export default {
    name: "customersMethods",

    async getCustomers() {
        try {
            const response = await fetch("/backend/customers", {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postCustomer(obj) {
        try {
            const response = await fetch("/backend/customers", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async deleteCustomer(obj) {
        try {
            const response = await fetch("/backend/customers/" + obj, {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async updateCustomer(obj) {
        try {
            const response = await fetch("/backend/customers/"+obj.id, {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    }
}